import {
  INSPECTION_STATUSES,
  InspectionCache,
  InspectionReport,
  InspectionStatus,
} from "../types/ownerPortfolio.types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function asNullableString(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
}

function asStatus(value: unknown): InspectionStatus {
  if (
    typeof value === "string" &&
    (INSPECTION_STATUSES as readonly string[]).includes(value)
  ) {
    return value as InspectionStatus;
  }

  return "unavailable";
}

function normalizeReport(value: unknown, status: InspectionStatus): InspectionReport | null {
  if (status !== "ready" || !isRecord(value)) {
    return null;
  }

  const label = asNullableString(value.label);
  const inspectedOn = asNullableString(value.inspected_on);
  const inspectedOnDisplay = asNullableString(value.inspected_on_display);
  const openPath = asNullableString(value.open_path);

  if (!label || !inspectedOn || !inspectedOnDisplay || !openPath) {
    return null;
  }

  return {
    inspected_on: inspectedOn,
    inspected_on_display: inspectedOnDisplay,
    label,
    open_path: openPath,
  };
}

export function normalizeInspectionCache(
  payload: unknown,
  fallbackKenloPropertyId: string
): InspectionCache {
  const data = isRecord(payload) ? payload : {};
  const status = asStatus(data.status);

  return {
    kenlo_property_id:
      asNullableString(data.kenlo_property_id) ?? fallbackKenloPropertyId,
    status,
    message: asNullableString(data.message),
    searched_at: asNullableString(data.searched_at),
    report: normalizeReport(data.report, status),
  };
}
